import { render, staticRenderFns } from "./ProcesoCompraAmigoAbonado.vue?vue&type=template&id=2b9efd97"
import script from "./ProcesoCompraAmigoAbonado.vue?vue&type=script&lang=js"
export * from "./ProcesoCompraAmigoAbonado.vue?vue&type=script&lang=js"
import style0 from "./ProcesoCompraAmigoAbonado.vue?vue&type=style&index=0&id=2b9efd97&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports